import type {
  Edit,
  SummaryBrand,
  HomePageSingleBrand,
} from "src/types/graphql.d";
import { SUPPORTED_KEYS } from "src/utils/constants";

export enum CarouselType {
  Edit = "edit",
  Brand = "brand",
}

export type CarouselItem = Edit | SummaryBrand;

export type SupportedKeys = (typeof SUPPORTED_KEYS)[number];

export type CarouselData = {
  title: string;
  type: SupportedKeys;
  data: HomePageSingleBrand[];
};
